import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "@app/env";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { catchError, retry, tap } from "rxjs/operators";
import { AuthData } from "./auth";
import { Utilities } from "./utilities";

@Injectable()
export class PurchasesData {
  private action: string = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private utilities: Utilities,
    private http: HttpClient,
    private authData: AuthData,
  ) { }

  public getAllByClient(clientId: string) {
    return this.afDb.list(`Clients/${clientId}/UserPaymentHistory`).valueChanges();
  }

  public updateDeliveredItem(userId: string, paymentId: string, itemId: string, clientId: string, type: string) {
    return this.afDb.database
      .ref(`Clients/${clientId}/UserPaymentHistory/${userId}/${paymentId}/summary/${type}/${itemId}/delivered`)
      .transaction((value) => !value);
  }

  /**
   * Se traen estadisticas necesarias de mongo
   * @param clientId
   * @param type
   */
  public getStatsMongo(
    clientId: string,
    action: "VIEW" | "ADD_TO_CART" | "REBUS_LOG",
    entityType: string, type: "list" | "count"): Observable<any> {
    return this.http.post(`${ENV.backend}/stats_ai/events`,
      { type, entity_type: entityType, client_id: clientId, action })
      .pipe(
        tap(() => this.utilities.consoleDecorator(`Stats ${action} to ${type}: `, entityType, "orange")),
        retry(3),
        catchError((err) => [this.utilities.consoleDecorator("Error ai stats: ", err, "orange")]),
      );
  }

  public getLogsPay(clientId: string, action: string = "REBUS_LOG", type: "list" | "count" = "list"): Observable<any> {
    return this.http.post(`${ENV.backend}/logs/search`, { type, client_id: clientId, action })
      .pipe(
        tap(() => this.utilities.consoleDecorator(`Stats pay ${action} to ${type}: `, "", "orange")),
        retry(3),
        catchError((err) => [this.utilities.consoleDecorator("Error pay stats: ", err, "orange")]),
      );
  }

  public getReportPayments(clientId: string) {
    return this.http.get(`${ENV.backend}/reports/payments/sync/${clientId}`)
      .pipe(
        retry(3),
        catchError((err) => [this.utilities.consoleDecorator("Error report generate: ", err, "orange")]),
      );
  }

  public associateAppPay(clientId: string, appId: string): Observable<any> {
    return Observable.fromPromise(this.authData.getUserData().getIdToken()).switchMap((token: any) => {
      const headers = new HttpHeaders({ Authorization: token });
      return this.http.get(`${ENV.pay_api_url}/v1/paymentez/associate/${clientId}/${appId}`, { headers })
        .pipe(
          retry(3),
          tap(() => this.utilities.consoleDecorator("Init asociate app pay: ", [clientId, appId], "#33691e")),
          catchError((err) => [this.utilities.consoleError("Error asociate app pay: ", err)],
          )).toPromise();
    });
  }

  public sendPaymentNotification(client: string, user: string, payment: string, to: string[]): Observable<any> {
    return Observable.fromPromise(this.authData.getUserData().getIdToken()).switchMap((token: any) => {
      const headers = new HttpHeaders({ Authorization: token });
      return this.http.post(`${ENV.backend}/notification/payment`,
        { client, user, payment, to },
        { headers },
      ).pipe(
        // retry(3),
        tap(() => this.utilities.consoleDecorator(
          "Send payment notification: ",
          [client, user, payment, to],
          "#33691e")),
        catchError((err) => [this.utilities.consoleError("Error send payment notification: ", err)],
        )).toPromise();
    });
  }

  public sendPaymentNotificationQR(client: string, user: string, payment: string) {
    return Observable.fromPromise(this.authData.getUserData().getIdToken()).switchMap((token: any) => {
      const headers = new HttpHeaders({ Authorization: token });
      return this.http.post(`${ENV.backend}/notification/ticket`,
        { client, user, payment },
        { headers },
      ).pipe(
        // retry(3),
        tap(() => this.utilities.consoleDecorator(
          "Send payment notification: ",
          [client, user, payment],
          "#33691e")),
        catchError((err) => [this.utilities.consoleError("Error send payment notification: ", err)],
        )).toPromise();
    });
  }

  public getAppRebus(): Observable<any> {
    return Observable.fromPromise(this.authData.getUserData().getIdToken()).switchMap((token: any) => {
      const headers = new HttpHeaders({ Authorization: token });
      return this.http.get(`${ENV.pay_api_url}/v1/paymentez/`, { headers })
        .pipe(
          retry(3),
          tap(() => this.utilities.consoleDecorator(`Get apps Rebus: `, "", "orange")),
          catchError((err) => [this.utilities.consoleError("Error get apps: ", err)]),
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/purchases.ts